import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const crmAdapter = createEntityAdapter()

const initialState = crmAdapter.getInitialState()

export const crmApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCrmList: builder.query({
            query: () => "/crm/getCrmDataList",
            validateStatus: (response, result) => {
                console.log(response)
                return response.status === 200 && !result.isError;
            },
            transformResponse: responseData => {
                return crmAdapter.setAll(initialState, responseData);
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        { type: 'Crm', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Crm', id}))
                    ]
                } else 
                    return [{ type: 'Crm', id: 'LIST'}]
            }
        }),
        extractFile: builder.mutation({
            query: (request) => {
                let formData = new FormData();
                formData.append('userId', request.userId);
                formData.append('file', request.file);

                return {
                  url: '/crm/extractFile',
                  method: 'POST',
                  body:  formData,
                  formData: true  
                };
              }
        }),
        getCrmIdByAdvisorId: builder.mutation({
            query: advisorId => ({
                url: '/crm/getCrmIdByAdvisorId/' + advisorId,
                method: 'GET'
            })
        }),
        downloadTemplates: builder.mutation({
            query: () => ({
                url: '/file/template/downloadTemplates',
                method: 'GET',
                responseHandler: ((response) => response.blob()),
                cache: "no-cache"
            })
        }),
    })
})

export const {
    useGetCrmListQuery,
    useExtractFileMutation,
    useGetCrmIdByAdvisorIdMutation,
    useDownloadTemplatesMutation,
} = crmApiSlice


//returns the query result object
export const selectCrmListResult = crmApiSlice.endpoints.getCrmList.select()

//creates memoized selector`
const selectCrmData = createSelector(
    selectCrmListResult,
    crmResult => crmResult.data //normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename with aliases using destructuring
export const {
    selectAll: selectAllCrm,
    selectById: selectCrmById,
    selectIds: selectCrmIds
    //Pass in a selector that returns the users slice of state
} = crmAdapter.getSelectors(state => selectCrmData(state) ?? initialState)